import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Main from './layouts/Main';
import NotFound from "./views/NotFound/NotFound";

// import routes
import protectedRoutes from "./routes/ProtectedRoutes";

import { useEffect } from 'react';
import { useAuthStore } from './hooks';
//import  Signin  from './views/Signin/Signin'; 
import Signin from "./views/Signin/Signin";
import Signup from './views/Signup/Signup'; // Importa tu componente de registro
import RecoverPasswordScreen from "./views/RecoverPassword/RecoverPassword";

// import css
import "./styles/assets/css/remixicon.css";

// import scss
import "./styles/scss/style.scss";


// set skin on load
window.addEventListener("load", function () {
  let skinMode = localStorage.getItem("skin-mode");
  let HTMLTag = document.querySelector("html");

  if (skinMode) {
    HTMLTag.setAttribute("data-skin", skinMode);
  }
});

export default function App() {

  const { status, checkAuthToken, abrirCargar } = useAuthStore();

  useEffect(() => {
      checkAuthToken();
  }, [])

  if ( status === 'checking' ) {
    abrirCargar();
  }

  return (
    <React.Fragment>
      {/* <BrowserRouter> */}
        <Routes>
          {status === 'not-authenticated' ? (
            <>
              <Route path="/" element={<Signin />} />
              <Route path="/pages/signup" element={<Signup />} /> {/* Ruta para registro */}
              <Route path="/pages/recoverPassword" element={<RecoverPasswordScreen />} /> {/* Ruta para registro */}
              <Route path="/*" element={<Signin />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Main />}>
              <Route path="/" element={<Navigate to="/pages/printUser" />} />
                {protectedRoutes.map((route, index) => {
                  return (
                    <Route
                      path={route.path}
                      element={route.element}
                      key={index}
                    />
                  )
                })}
              </Route>
            </>
          )}
          <Route path="*" element={<NotFound />} />
        </Routes>
      {/* </BrowserRouter> */}
    </React.Fragment>
  )
}